export default __webpack_public_path__ + "media/flags/sa-6076fa70.svg";